import { render, staticRenderFns } from "./AddLetterDoc.vue?vue&type=template&id=0efbea54"
import script from "./AddLetterDoc.vue?vue&type=script&lang=js"
export * from "./AddLetterDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0efbea54')) {
      api.createRecord('0efbea54', component.options)
    } else {
      api.reload('0efbea54', component.options)
    }
    module.hot.accept("./AddLetterDoc.vue?vue&type=template&id=0efbea54", function () {
      api.rerender('0efbea54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/announcements/AddLetter/components/AddLetterDoc.vue"
export default component.exports